<script>
import users from "../components/settings/setting-accountUsers.vue";
import usersRoles from "../components/settings/setting-usersRoles.vue";
import teams from "../components/settings/setting-teams.vue";

const SECTIONS = [
  {
    key: "users",
    label: "Users",
    icon: "users",
  },
  {
    key: "roles",
    label: "Roles",
    icon: "shield",
  },
  {
    key: "teams",
    label: "Teams",
    icon: "grid",
  },
];

export default {
  name: "UsersPage",
  components: {
    users,
    usersRoles,
    teams
  },
  data() {
    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem("experience-banner::users::dismissed") === "1";
    } catch (e) {
      // localStorage unavailable
    }
    const hash = (window.location.hash || "").replace("#", "");
    return {
      user: this.$A.Auth,
      bannerDismissed: dismissed,
      sections: SECTIONS,
      activeSection: SECTIONS.some((s) => s.key === hash) ? hash : "users",
    }
  },
  methods: {
    setRoles: function(roles) {
      this.$refs.users.setRoles(roles);
      this.$refs.users.updateUsers(false);
    },
    setTeams: function(teams) {
      this.$refs.users.setTeams(teams);
    },
    loadTeams: function() {
      this.$refs.teams.loadTeams(true);
    },
    selectSection(key) {
      this.activeSection = key;
      try {
        window.history.replaceState(null, "", `#${key}`);
      } catch (e) {
        window.location.hash = key;
      }
    },
    dismissBanner() {
      this.bannerDismissed = true;
      try {
        window.localStorage.setItem("experience-banner::users::dismissed", "1");
      } catch (e) {
        // localStorage unavailable
      }
    },
  },
}
</script>


<template>
  <div class="nav-margin users-page">
    <navigation></navigation>

    <div class="page-body">
      <div class="experience-switch" v-if="!bannerDismissed">
        <div class="experience-msg">
          <span class="experience-pill">New</span>
          <span class="experience-text">You're using the new users page.</span>
        </div>
        <div class="experience-actions">
          <button type="button" class="experience-link experience-link-btn" v-b-modal="'feedbackModal-newUsers'">Give feedback</button>
        </div>
        <button
          type="button"
          class="experience-close"
          @click="dismissBanner"
          aria-label="Dismiss banner"
          title="Dismiss"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <feedbackModal
        name="feedbackModal-newUsers"
        campaign-key="new-users-v1"
        title="How is the new users page?"
        subtitle="Your take helps us decide what to improve."
        scale-question="How would you rate the new users page experience?"
        :scale-min="1"
        :scale-max="7"
        scale-low-label="Not great"
        scale-high-label="Excellent"
        text-prompt="What's working or not working?"
        text-placeholder="Tell us anything that helps."
        submit-label="Send feedback"
      />

      <div class="users-shell">
        <aside class="settings-rail">
          <div class="rail-head">
            <div class="rail-head-title">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <span>Users &amp; Teams</span>
            </div>
          </div>

          <nav class="rail-scroll" aria-label="Users page sections">
            <button
              v-for="section in sections"
              :key="section.key"
              type="button"
              class="rail-nav-item"
              :class="{ 'is-active': activeSection === section.key }"
              @click="selectSection(section.key)"
            >
              <svg v-if="section.icon === 'users'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <svg v-else-if="section.icon === 'shield'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
              <span>{{ section.label }}</span>
            </button>
          </nav>
        </aside>

        <main class="users-main">
          <div class="users-main-inner">
            <div v-show="activeSection === 'users'" class="section-stack">
              <users ref="users" @updated="loadTeams"/>
            </div>
            <div v-show="activeSection === 'roles'" class="section-stack">
              <users-roles @updated="setRoles"/>
            </div>
            <div v-show="activeSection === 'teams'" class="section-stack">
              <teams ref="teams" @updated="setTeams"/>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* The document scrolls naturally (promo banners etc. can add height
   above us); the rail stays pinned via position:sticky instead of a
   fixed-height shell, so there's a single page scrollbar. */
.page-body {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px); /* clear position:fixed nav */
}

/* Experience banner */
.experience-switch {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
  padding: 8px 48px;
  background: rgba(1, 146, 86, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-size: 13px;
  color: #4b5563;
  flex-shrink: 0;
}
.experience-msg,
.experience-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.experience-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #019256;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.experience-link {
  color: #019256;
  font-weight: 600;
  text-decoration: none;
}
.experience-link:hover {
  text-decoration: underline;
  color: #017a48;
}
.experience-link-btn {
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
.experience-close {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.experience-close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #111827;
}

/* Shell: sidebar + main column, like the proof list */
.users-shell {
  display: flex;
  align-items: stretch;
  flex: 1;
  background: #f4f5f7;
  position: relative;
}
.settings-rail {
  width: 288px;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: 64px; /* below the fixed nav */
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  background: #fbfbfc;
  border-right: 1px solid rgba(15, 23, 42, 0.08);
  overflow: hidden;
}
.rail-head {
  flex-shrink: 0;
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 14px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.rail-head-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.rail-head-title svg {
  color: #019256;
  flex-shrink: 0;
}
.rail-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  scrollbar-width: thin;
}
.rail-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 120ms ease, color 120ms ease;
}
.rail-nav-item svg {
  flex-shrink: 0;
  color: #9ca3af;
  transition: color 120ms ease;
}
.rail-nav-item:hover {
  background: rgba(15, 23, 42, 0.04);
  color: #111827;
}
.rail-nav-item.is-active {
  background: rgba(1, 146, 86, 0.08);
  color: #017a48;
  font-weight: 600;
}
.rail-nav-item.is-active svg {
  color: #019256;
}

/* Main column — scrolls with the document */
.users-main {
  flex: 1;
  min-width: 0;
  background: #f4f5f7;
}
.users-main-inner {
  max-width: 991px;
  margin: 0 auto;
  padding: 24px;
}
.section-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Mobile */
@media (max-width: 991px) {
  .users-shell {
    flex-direction: column;
  }
  .settings-rail {
    width: 100%;
    position: static;
    height: auto;
    border-right: 0;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  }
  .rail-head {
    display: none;
  }
  .rail-scroll {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 8px 12px;
  }
  .rail-nav-item {
    flex-shrink: 0;
    width: auto;
    white-space: nowrap;
  }
  .users-main-inner {
    padding: 16px;
  }
}
</style>
